import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CourseManagmentService } from 'src/app/services/course-managment.service';
import { CollabProfileImageComponent } from '../../collaborator/collaborator-profile-image/collab-profile-image.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ExportService } from 'src/app/services/export.service';

@Component({
  selector: 'app-participant-list-modal',
  standalone: true,
  imports: [ CommonModule,
            CollabProfileImageComponent, 
             MatProgressSpinnerModule,],
  templateUrl: './participant-list-modal.component.html',
  styleUrl: './participant-list-modal.component.scss'
})
export class ParticipantListModalComponent {
  participantList: any;
  loadingParticipant: boolean=false;
  participantNumber: number=0;

  constructor(
     private courseManagmentService: CourseManagmentService,
     @Inject(MAT_DIALOG_DATA) public data: any,
     public dialogRef: MatDialogRef<ParticipantListModalComponent>,
     private exportService: ExportService


   ) 
   {}
   
  ngOnInit() {
  this.loadParticipantList(this.data.courseId);
  }



  loadParticipantList(info: any) {
    this.loadingParticipant=true;
    this.courseManagmentService.getParticipantListByCourseById(this.data.courseId).subscribe(
      (result:any) => {    
         this.participantList=result.participantList;  
         this.participantNumber=result.participantNumber;  
        this.loadingParticipant=false;
   
      }
    );
}

onCancelClick(): void {
  this.dialogRef.close();
}

exportParticipants(): void {
  const formattedData = this.participantList.map((participantList: { firstname: any; lastname: any; id: any; assignment: any; }) => ({
    'Nom du collaborateur': `${participantList.firstname} ${participantList.lastname}`,
    Matricule: participantList.id,
    Affectation: participantList.assignment,
  }));

  this.exportService.exportToExcel(formattedData, 'Liste_Participants');
}

}
